import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { Attribute, ChangeDetectionStrategy, Component, EventEmitter, Input, Optional, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { IconName } from "@enersis/gp-components/gp-icon";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "tpm-dialog-frame",
  templateUrl: "./dialog-frame.component.html",
  styleUrls: ["./dialog-frame.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { "[class.alt-theme]": "altTheme" }
})
export class DialogFrameComponent {
  @Input() public icon: IconName | string;
  @Input() public header: string;
  @Input() public closable: boolean = true;

  @Input() public width: string = "100%";

  @Input() public hasSticky: boolean = false;
  @Input() public hasFooter: boolean = true;
  @Input() public footerDivider: boolean = false;
  @Input() public hasCloseButton: boolean = true;
  @Input() public submitDisabled: boolean = false;

  /**
   * Name of the form to be submitted.
   * Setting this property will automatically set the submit button to be of type "submit".
   * */
  @Input() public submitForm?: string = null;

  @Input() public closeButtonLabel: string;
  @Input() public submitButtonLabel: string;

  @Output() public readonly closed = new EventEmitter<void>();
  @Output() public readonly submitted = new EventEmitter<void>();

  constructor(
    @Attribute("alt-theme")
    @Optional()
    readonly altTheme: boolean,
    private readonly matDialog: MatDialog
  ) {
    this.altTheme = coerceBooleanProperty(this.altTheme);
  }

  public onClose(event?: CustomEvent<void>): void {
    event?.stopPropagation();
    this.closed.emit();

    if (this.closable) {
      this.matDialog.closeAll();
    }
  }

  public onSubmit(): void {
    this.submitted.emit();
  }
}
